var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6418_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 19.9219C15.4102 19.9219 19.9219 15.4004 19.9219 9.96094C19.9219 4.51172 15.4004 0 9.95117 0C4.51172 0 0 4.51172 0 9.96094C0 15.4004 4.52148 19.9219 9.96094 19.9219ZM9.96094 18.2617C5.35156 18.2617 1.66992 14.5703 1.66992 9.96094C1.66992 5.35156 5.3418 1.66016 9.95117 1.66016C14.5605 1.66016 18.2617 5.35156 18.2617 9.96094C18.2617 14.5703 14.5703 18.2617 9.96094 18.2617ZM9.75586 11.9824C10.2441 11.9824 10.5469 11.6699 10.5469 11.2891C10.5469 11.25 10.5469 11.2012 10.5469 11.1719C10.5469 10.625 10.8594 10.2734 11.543 9.82422C12.4902 9.19922 13.1641 8.63281 13.1641 7.46094C13.1641 5.83984 11.7188 4.96094 10.0586 4.96094C8.37891 4.96094 7.27539 5.76172 7.01172 6.66016C6.96289 6.81641 6.93359 6.97266 6.93359 7.13867C6.93359 7.57812 7.27539 7.8125 7.59766 7.8125C7.92969 7.8125 8.14453 7.65625 8.32031 7.42188L8.49609 7.1875C8.83789 6.62109 9.3457 6.28906 10 6.28906C10.8887 6.28906 11.4648 6.79688 11.4648 7.53906C11.4648 8.20312 11.0547 8.52539 10.2051 9.12109C9.50195 9.60938 8.97461 10.127 8.97461 11.084C8.97461 11.123 8.97461 11.1719 8.97461 11.2109C8.97461 11.7188 9.25781 11.9824 9.75586 11.9824ZM9.73633 14.8926C10.3027 14.8926 10.791 14.4434 10.791 13.877C10.791 13.3105 10.3125 12.8613 9.73633 12.8613C9.16016 12.8613 8.68164 13.3203 8.68164 13.877C8.68164 14.4336 9.16992 14.8926 9.73633 14.8926Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6418_1283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9219,
    height: 19.9316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarHelp);
export default __webpack_public_path__ + "static/media/tabbar-help.790610e7dd29db3e62a2c8fb83142995.svg";
export { ForwardRef as ReactComponent };